import gsap from 'gsap'
import ScrollFollowNavigation from '../_main/ScrollFollowNavigation'

class FirstViewChanger {
  constructor(el) {
    this.dom = { el: el };
    this.dom.container = document.querySelector('[data-js="modechange"]');
    this.dom.label = document.querySelector('[data-js="mode"]');

    this.dom.cover = document.querySelector('[data-js="change-cover"]');
    this.dom.copy = document.querySelector('[data-js="copy"]');
    this.dom.plus = document.querySelector('[data-js="plus"]');
    this.dom.textver = document.querySelector('[data-js="text"]');
    this.dom.animver = document.querySelector('[data-js="animation"]');

    this.beforeMode = null;
    this.mode = 'animation';
    this.change = this.change.bind(this);

    this.sfn = null;

    this.duration = .6;

    // ページ内スクロール
    this.domScrollFollowNavigation = document.querySelectorAll('[data-trigger="sfn"]');

    this.init();
  }

  init() {
    this.dom.el.addEventListener('click', this.change);
    this.initFollowNavigation();
  }

  change() {
    this.beforeMode = this.mode;

    gsap.to(this.dom.cover, {
      opacity: 1,
      duration: this.duration,
      onComplete: () => {

        if (this.mode === 'animation') {
          // animation ver → text ver

          this.mode = this.dom.container.dataset.mode = 'text';

          this.dom.plus.style.display = 'none';
          this.dom.copy.style.display = 'none';
          this.dom.animver.style.display = 'none';
          this.dom.textver.style.display = 'block';

          setTimeout(()=>{
            window.scroll({top: 0, behavior: 'instant'});

            gsap.to(this.dom.cover, {
              opacity: 0,
              duration: this.duration,
            })

            this.restartFollowNavigation();
          }, 100)

        } else {
          // text ver → animation ver

          this.mode = this.dom.container.dataset.mode = 'animation';

          this.dom.plus.style.display = 'block';
          this.dom.copy.style.display = 'block';
          this.dom.animver.style.display = 'block';
          this.dom.textver.style.display = 'none';

          setTimeout(()=>{
            window.scroll({top: 0, behavior: 'instant'});

            gsap.to(this.dom.cover, {
              opacity: 0,
              duration: this.duration,
            })

            this.restartFollowNavigation();
          }, 100)

        }

        this.dom.label.textContent = this.beforeMode;
      }
    })
  }

  initFollowNavigation() {
    if (this.domScrollFollowNavigation)
      this.sfn = new ScrollFollowNavigation(this.domScrollFollowNavigation);
  }

  restartFollowNavigation() {
    this.destoryFollowNavigation();
    this.initFollowNavigation();
  }

  destoryFollowNavigation() {
    if (this.sfn)
      this.sfn.destroy();
  }
}

export default FirstViewChanger;
